module.exports = __webpack_public_path__ + "static/Alt Balaji-c8b7c6d546a3eb60ac8fc90386c6be8d.png";